"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ShrinkOutline = {
  name: 'shrink',
  theme: 'outline',
  nameWithTheme: 'shrink-o',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    class: 'icon',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M881.7 187.4l-45.1-45.1c-3.1-3.1-8.2-3.1-11.3 0L667.8 299.9l-54.7-54.7c-4.7-4.7-12.7-1.9-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5c-3.1 3.1-3.1 8.2 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7c4.7 4.7 12.7 1.9 13.5-4.7L447.9 585c.7-5.2-3.7-9.6-8.9-8.9z'
    },
    children: []
  }]
};
exports.default = ShrinkOutline;